export const SET_INTERACTION_DATA = "SET_INTERACTION_DATA";
export const SET_ACTIVITY_INTERACTION_DATA = "SET_ACTIVITY_INTERACTION_DATA";
export const SET_SELECTED_INTERACTION_DATA = "SET_SELECTED_INTERACTION_DATA";
export const GET_SHOP_SITE_DATA = "GET_SHOP_SITE_DATA";
export const GET_BRAND_SHOPIFY = "GET_BRAND_SHOPIFY";
export const SET_SHOPIFY_ALL_DATA = "SET_SHOPIFY_ALL_DATA";
export const SET_SHOP_COM_ALL_DATA = "SET_SHOP_COM_ALL_DATA";
export const GET_PRODUCT_DETAILS = "GET_PRODUCT_DETAILS";
export const GET_PRODUCT_DETAIL = "GET_PRODUCT_DETAIL";
export const GET_PRODUCTS_IN_CART = "GET_PRODUCTS_IN_CART";
export const CLEAR_PRODUCT_DATA = "CLEAR_PRODUCT_DATA";
export const SET_PRODUCT_DETAILS_LOADING = "SET_PRODUCT_DETAILS_LOADING";